import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import * as keyboard from 'util/Keyboard';
import Modal from 'ui-library/modals/Modal';
import * as ModalContainer from 'ui-library/ModalContainer';

const COPY_MODAL_KEY = 'COPY_MODAL_KEY';

class CopyTextModal extends React.Component {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    onCopy: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
  };

  static close() {
    ModalContainer.close(COPY_MODAL_KEY);
  }

  static open(props) {
    ModalContainer.open(
      COPY_MODAL_KEY,
      <CopyTextModal
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, props, {
          onRequestClose: CopyTextModal.close,
        })}
      />
    );
  }

  componentDidMount() {
    const node = ReactDOM.findDOMNode(this.refs.textarea);
    node.focus();
    node.select();
  }

  render() {
    return (
      <Modal
        enableRedesign={false}
        title={`Press ${keyboard.ctrl}-C to copy`}
        onRequestClose={this.props.onRequestClose}
        wrapInForm={false}
        buttons={[
          {
            text: 'Cancel',
            cancel: true,
          },
        ]}
      >
        <textarea
          ref="textarea"
          style={{whiteSpace: 'pre-wrap'}}
          readOnly={true}
          value={this.props.text}
          onCopy={this.props.onCopy}
          rows={5}
        />
      </Modal>
    );
  }
}

export default CopyTextModal;
